<template>
  <v-container>
    <div class="text-h4">Are you moving phone numbers from your previous provider?</div>
    <v-radio-group :value="getProductInfo().porting" @change="setPortingAnswer">
      <v-radio label="Yes" value="y"></v-radio>
      <v-radio label="No" value="n"></v-radio>
    </v-radio-group>

    <!-- <TollfreePorting /> -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import TollfreePorting from '@/components/cards/TollfreePorting.vue';

export default {
  name: 'Porting',
  methods: {
    ...mapActions(['updateStoreFormData', 'updateNewNumbersField']),
    setPortingAnswer(newVal) {
      const vm = this;
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'porting',
      }).then(() => {
        vm.updateNewNumbersField();
      });
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
  },
  components: {
    // TollfreePorting,
  },
};
</script>
